<template>
  <div class="teacher-main-wrapper">
    <div
      style="padding: 42px 0 54px; margin: 0 auto; width: 1200px; display: flex"
    >
      <div class="teacher-wrapper">
        <div class="main-title">
          <span class="text">推荐教师</span>
          <span class="eng">Recommended Teachers</span>
          <a :href="`${this.$baseUrl}${abbr}/teacherList/teacherList.html`"
            class="more-btn"
            style="margin-top: 14px"
          >
            <span class="btn-text">查看全部</span>
            <i class="iconfont icongengduo"></i>
          </a>
        </div>
        <div class="teacher-list">
            <template v-if="teacherList && teacherList.length">
              <div v-for="{introduc,file_url,name,college_name, teacher_id, source_user_id} in teacherList" :key="teacher_id" class="teacher-card"  @click="showTeacherDetail(teacher_id, source_user_id)">
                <div class="tea-img"><img :src="file_url" alt=""/></div>
                <div class="tea-mes">
                  <div class="tea-name text-overflow" :title="name">{{name}}</div>
                  <div class=" tea-title text-overflow" :title="college_name">{{college_name}}</div>
                  <div class=" tea-intro">{{(introduc || '').replace(/<\/?[^>]*>/g, '').replace(/[|]*\n/, '').replace(/&npsp;/ig, '')}}</div>
                </div>
              </div>
            </template>
          <div v-else class="no-data">
            <img
              src="//image.zhihuishu.com/zhs_yufa_150820/ablecommons/demo/202011/e8db1963d817430a924d9def022fad09.png"
            />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div class="nav-wrapper">
        <div
          class="teach item"
          onclick="window.open('http://dzzy.zhihuishu.com/hrbeu/homeController/queryTrainingView')"
        >
          <div class="title">本科教育培养方案</div>
          <div class="link">查看详情</div>
        </div>
        <div
          class="index item"
          onclick="window.open('http://dzzy.zhihuishu.com/hrbeu/homeController/queryCourseOutline')"
        >
          <div class="title">专业教学课程大纲</div>
          <div class="link">查看详情</div>
        </div>
      </div>
    </div>
    <!-- <DialogTeacherDetail  
      :visible="dialogTeacherVisible"
      :teacher-data="currentTeacher"
      :handle-close="closeTeacherDetail"/> -->
  </div>
</template>
<script>
// import DialogTeacherDetail from "./../../components/DialogTeacherDetail";
import config from '../../config'
export default {
  // components: {
  //   DialogTeacherDetail,
  // },
  created() {
    this.getTeacherList();
  },
  data() {
    return {
      teacherList: [],
      dialogTeacherVisible: false,
      currentTeacher: {},
      abbr: config.abbr
    };
  },
  methods: {
     // 查看详情
    showTeacherDetail(teacher_id, source_user_id) {
      // this.currentTeacher = 
      console.log(this.teacherList);
      // this.dialogTeacherVisible = true;
      window.location.href = `/swh5/HEU/teacherList/teacherDetailInfo.html?id=${teacher_id}&sourceUserId=${source_user_id}`
    },
      // 关闭详情
    // closeTeacherDetail() {
    //   this.currentTeacher = {};
    //   this.dialogTeacherVisible = false;
    // },
    async getTeacherList() {
      const list = await this.$http.HEU.getHomeTeacherList({
        '_pageable.page': 0,
        '_pageable.size': 3
      })
      this.teacherList = list.content
      console.log(list.content);
    },
  },
};
</script>
